export const ITEMS_PER_PAGE = 10;

export const INITIAL_INVENTORY_ARTICLE_STATE = {
  uuid: null,
  code: '',
  name: '',
  description: '',
  uuid_unit: '',
  external_code: '',
  is_active: true,
};

export const VALIDATION_RULES = {
  REQUIRED_FIELDS: ['code', 'name'],
  CODE_MAX_LENGTH: 50,
  NAME_MAX_LENGTH: 150,
  EXTERNAL_CODE_MAX_LENGTH: 80,
};

export const MESSAGES = {
  ERROR: {
    REQUIRED_FIELD: 'Este campo es obligatorio',
    INVALID_CODE: 'El código no puede estar vacío',
    INVALID_NAME: 'El nombre no puede estar vacío',
    INVALID_QUANTITY: 'La cantidad debe ser mayor a cero',
    REQUIRED_REASON: 'El motivo es obligatorio',
    REQUIRED_WAREHOUSE: 'El depósito es obligatorio',
    NEGATIVE_STOCK: 'El egreso no puede dejar stock físico negativo',
  },
};

export const ADJUSTMENT_TYPES = {
  IN: 'in',
  OUT: 'out',
};

export const ADJUSTMENT_TYPE_OPTIONS = [
  { value: ADJUSTMENT_TYPES.IN, label: 'Ingreso' },
  { value: ADJUSTMENT_TYPES.OUT, label: 'Egreso' },
];

export const INITIAL_ADJUST_STOCK_STATE = {
  uuid_warehouse: '',
  adjustmentType: ADJUSTMENT_TYPES.IN,
  quantity: '',
  reason: '',
};

export const MOVEMENT_TYPE_LABELS = {
  transfer_in: 'Ingreso por traslado',
  transfer_out: 'Egreso por traslado',
  consumption: 'Consumo',
  adjustment_in: 'Ajuste de ingreso',
  adjustment_out: 'Ajuste de egreso',
  reservation: 'Reserva',
  reservation_release: 'Liberación de reserva',
  reversal: 'Reversión',
};

export const ALL_WAREHOUSES_FILTER = 'all';
